export default __webpack_public_path__ + "static/media/doobi_green.851447d7.png";